import { useLazyQuery } from "@apollo/client/react"; import React, { useMemo, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import {
  Button,
  TextField,
  InputAdornment
} from
  '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useDebounce } from '../../../hooks/useDebounce';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { GET_PROVEEDORES } from '../../../data/graphQL/queries/Utils/queries';

import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export const BuscarProveedor = ({ open, onClose, onRowClick }) => {

  const [
    rows,
    setRows,
    proveedoresOriginal,
    setProveedoresOriginal,
    filterStatus,
    setFilterStatus] =
    useGetProveedores();

  const txtFiltroProveedor = useRef(null);

  const initialColumns = [
    {
      field: 'cod_Proveedor',
      headerName: 'Código'
    },
    {
      field: 'nombre',
      headerName: 'Nombre'
    },
    {
      field: 'cUIT',
      headerName: 'CUIT'
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const handleCleanProveedor = () => {
    txtFiltroProveedor.current.value = "";
    handleSearchProveedor();
    txtFiltroProveedor.current.focus();
  };

  const handleCloseDlgProveedor = () => {
    handleCleanProveedor();
    onClose();
  };

  const handleSearchProveedor = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltroProveedor.current.value != "") {
      if (txtFiltroProveedor.current.value.length >= 3) {
        setRows(proveedoresOriginal.filter((proveedoresOriginal) => {
          const nombreBuscar = proveedoresOriginal.nombre.toLowerCase();
          const codigoBuscar = proveedoresOriginal.cod_Proveedor.toLowerCase();
          const cuitBuscar = proveedoresOriginal.cUIT.toLowerCase();

          const inputBuscar = txtFiltroProveedor.current.value;
          return (
            nombreBuscar.includes(inputBuscar) ||
            codigoBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      setRows(proveedoresOriginal);
    }
  };

  return (
    <CustomDialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
      title={'Búsqueda de Proveedores'}
      onCancel={handleCloseDlgProveedor}>

      <div className='buscarcliente-dialog-content'>
        <div className='filtros-buscar-cliente'>
          <TextField
            label="Filtrar"
            name="txtFiltroProveedor"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtFiltroProveedor}
            style={{ marginBottom: 20 }}
            onKeyUp={handleSearchProveedor}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleSearchProveedor}
                    sx={{ cursor: 'pointer' }} />

                  <ClearIcon
                    onClick={handleCleanProveedor}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </div>
        <DataGridGenerico
          columns={columns}
          rows={rows}
          toolbar={false}
          onRowClick={onRowClick} />

      </div>
    </CustomDialog>);

};


const useGetProveedores = () => {
  const [proveedores, setProveedores] = useState([]);
  const [proveedoresOriginal, setProveedoresOriginal] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getProveedores, { data: proveedoresData, loading: proveedoresLoading }] = useLazyQuery(GET_PROVEEDORES, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!proveedoresData) return;
    setProveedores(proveedoresData.proveedores.valorEsperado);
    setProveedoresOriginal(proveedoresData.proveedores.valorEsperado);
  }, [proveedoresData]);  

  useEffect(() => {
    if (!proveedoresLoading) {
      getProveedores();
    }
  }, [debouncedFilterValue]);
  return [
    proveedores || [],
    setProveedores,
    proveedoresOriginal,
    setProveedoresOriginal,
    filterStatus,
    setFilterStatus];

};